<mat-card *ngIf="permissionsInited">
  <h2>Meine Zugänge</h2>

  <p class="no-permissions-info" *ngIf="!permissions || permissions?.length === 0">
    Keine Zugänge verfügbar.
  </p>
  <div class="permissions-row">

    <ng-container *ngIf="permissions && permissions.length">
      <ng-container *ngFor="let p of permissions">
        <div [ngClass]="{highlight: claimHighlight(p)}" class="custom-claim-card">
          <div class="options" (click)="toggleMenu(menu)" aria-label="Example icon-button with a menu">
            <fa-icon style="color: #282f0d" [icon]="['fas', 'ellipsis-v']"></fa-icon>
          </div>

          <div class="custom-menu" #menu>
            <div class="menu-item" (click)="openPermission(p)">
              <fa-icon [icon]="['fas', 'external-link-alt']"></fa-icon>
              <span>Zur Anwendung</span>
            </div>

            <div class="menu-item" (click)="showInfo(p)">
              <fa-icon [icon]="['fas', 'info']"></fa-icon>
              <span>Informationen</span>
            </div>

            <div class="menu-item" (click)="removePermission(p)">
              <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
              <span>Löschen</span>
            </div>
          </div>
          <div class="inner-card" (click)="openPermission(p)">
            <div class="image-container">
              <img class="cover" src="{{getClaimImage(p.claim_name)}}">
            </div>

            <div class="content">
              <h4 class="title">{{claimDesc[p.claim_name]}}</h4>
              <span class="sub-title">
              {{showDate(p.expires)}}
          </span>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="custom-claim-card" (click)="openNewClaimDialog()">
      <div class="inner-card">
        <div style="height: 145px" class="image-container vertical-center">
          <img class="icon" style="object-fit: unset; height: 35%" src="assets/plus.svg">
        </div>
        <div style="text-align: center; height: 45px" class="content">
          <h4 class="title grey">Zugang hinzufügen</h4>
        </div>
      </div>
    </div>
  </div>

</mat-card>

<mat-card *ngIf="scopedCustomerDomains && scopedCustomerDomains.length">
  <h2>Organisationszugang beantragen</h2>

  <mat-accordion>
    <div *ngFor="let scd of scopedCustomerDomains;">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{scd.name}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let d of scd.domains">
            <h4 matLine>{{d.claim.desc}}</h4>
            <button *ngIf="d.c2c"
                    mat-flat-button
                    matTooltip="Einladungs-E-Mail erneut senden"
                    matTooltipPosition="above"
                    color="danger" (click)="resendInvitation(d)">
              <fa-icon [icon]="['far', 'paper-plane']"></fa-icon>
            </button>
            <button *ngIf="!d.c2c"
                    mat-flat-button
                    matTooltip="Organisationszugang beantragen"
                    matTooltipPosition="above"
                    color="danger"
                    (click)="submitClaim(d)">
              <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </div>

  </mat-accordion>

</mat-card>

